import * as storage from '@inqool/uas-web-core/es/utils/storage';
import { get } from 'lodash';
import { PeriodType } from './_periodsTypes';

export const PeriodTypesEnum =
  get(storage.safeGet('extensions'), 'compact-attendance') === 'true'
    ? // compact
      [
        { id: PeriodType.VACATION, label: 'dovolená' },
        { id: PeriodType.COMP_TIME_OFF, label: 'náhradní volno' },
        { id: PeriodType.WORKING_HOURS, label: 'pracovní doba' },
        { id: PeriodType.BREAK, label: 'přestávka' },
        { id: PeriodType.SAFETY_SWITCH, label: 'bezpečnostní přestávka' },
        { id: PeriodType.UNEXCUSED_ASBENCE, label: 'neomluvená absence' },
        { id: PeriodType.ILLNESS, label: 'nemoc' },
        { id: PeriodType.INDISPOSED_VACATION, label: 'indispoziční volno' },
        { id: PeriodType.OVERTIME, label: 'přesčas' },
        { id: PeriodType.OVERTIME_SUBSTITUTE_VACATION, label: 'přesčas na náhradní volno' },
        { id: PeriodType.OVERTIME_UNPAID, label: 'neplacený přesčas' }
      ]
    : // not compact
      [
        { id: PeriodType.VACATION, label: 'dovolená' },
        { id: PeriodType.MAGIVOZ, label: 'magistrátní volno k osobním záležitostem' },
        { id: PeriodType.COMP_TIME_OFF, label: 'náhradní volno' },
        { id: PeriodType.BLOOD_DONATION, label: 'darování krve' },
        { id: PeriodType.OTHER_VACATION_WEDDING, label: 'ostatní volna - svatba' },
        { id: PeriodType.OTHER_VACATION_FUNERAL, label: 'ostatní volna - pohřeb' },
        { id: PeriodType.OTHER_VACATION_DOCTOR, label: 'ostatní volna - lékař' },
        { id: PeriodType.OTHER_VACATION_UNPAID, label: 'ostatní volna - neplacené volno' },
        { id: PeriodType.OVERTIME_25, label: 'přesčas - 25%' },
        { id: PeriodType.OVERTIME_50, label: 'přesčas - 50%' },
        { id: PeriodType.CONT_TIME_OFF, label: 'nepřetržité volno' },
        { id: PeriodType.WORKING_HOURS, label: 'pracovní doba' },
        { id: PeriodType.BREAK, label: 'přestávka' },
        { id: PeriodType.UNEXCUSED_ASBENCE, label: 'neomluvená absence' },
        { id: PeriodType.ILLNESS, label: 'nemoc' },
        { id: PeriodType.INDISPOSED_VACATION, label: 'indispoziční volno' },
        { id: PeriodType.OVERTIME, label: 'přesčas' },
        { id: PeriodType.OVERTIME_SUBSTITUTE_VACATION, label: 'přesčas na náhradní volno' },
        { id: PeriodType.OVERTIME_UNPAID, label: 'neplacený přesčas' }
      ];



// WEBPACK FOOTER //
// ./src/modules/hr-templates/periods/_periodsEnums.ts